var mentions_default = {
  "mentionPalette": "Auwd-",
  "mention": "STDOf",
  "mentionViewer": "-uetz",
  "mentionSuggestionsEntry": "kK9mj",
  "mentionSuggestionsEntryFocused": "_4kWPp",
  "mentionSuggestionsEntryText": "smwGO",
  "mentionSuggestionsEntryAvatar": "jxzNG",
  "mentionSuggestions": "YuGwL",
  "cursorDefault": "rNXcy",
  "cursorPointer": "_3uNzE"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
